<template>
    <div class="ur-gnb" v-if="!multiLine" :style="urGnbStyle">
        <div class="ur-gnb__logo" :class="{'ur-gnb__logo-center':logoCenter}">
            <label class="ur-gnb__title" @click="goToHome">{{title}}</label>
            <label class="ur-gnb__sub-title">{{subTitle}}</label>
        </div>
        <div v-if="!hasSearch && !hamburger" class="ur-gnb__menus" :class="{'ur-gnb__menus-center':menuCenter}">
            <ul>
                <li v-for="m in topMenu" @click="moveMenu(m.url)" class="ur-gnb__menu"
                    :class="{'ur-gnb__menu--selected':chkMenu(m)}">
                    {{m.name}}
                </li>
            </ul>
        </div>
        <div v-if="hamburger" class="ur-gnb__menus ur-gnb__menus-hamburger">
            <ur-drop-holder :items="hamburgerMenu" :value="currUri" @input="moveMenu">
                <ur-icon medium icon="drawer"/>
            </ur-drop-holder>
        </div>
        <div class="ur-gnb__action" >
            <slot>
            </slot>
        </div>
        <div v-if="hasSearch" class="ur-gnb__search" :class="{'ur-gnb__search-center':searchCenter}">
            <ur-text-field class="ur-gnb__search-text-field" v-model="searchKeyword" searchable @click-icon="doSearch"/>
        </div>
    </div>
    <div class="ur-gnb__multi-line" v-else :style="urGnbStyle">
        <div class="ur-gnb__multi-line-top">
            <div class="ur-gnb__logo">
                <label class="ur-gnb__title" @click="goToHome">{{title}}</label>
                <label class="ur-gnb__sub-title">{{subTitle}}</label>
            </div>
            <div class="ur-gnb__action" >
                <slot>
                </slot>
            </div>
            <div v-if="searchCenter" class="ur-gnb__search ur-gnb__search-center">
                <ur-text-field class="ur-gnb__search-text-field" v-model="searchKeyword" searchable @click-icon="doSearch"/>
            </div>
        </div>
        <div class="ur-gnb__multi-line-bottom">
            <div class="ur-gnb__menus" :class="{'ur-gnb__menus-center':menuCenter}">
                <ul>
                    <li v-for="m in topMenu" @click="moveMenu(m.url)" class="ur-gnb__menu"
                        :class="{'ur-gnb__menu--selected':chkMenu(m)}">
                        {{m.name}}
                    </li>
                </ul>
            </div>
            <div v-if="search" class="ur-gnb__search">
                <ur-text-field class="ur-gnb__search-text-field" v-model="searchKeyword" searchable @click-icon="doSearch"/>
            </div>
        </div>
    </div>
</template>

<script>
    // ur-gnb 는 화면의 GNB 영역을 구성하는 컴포넌트입니다.
    // 화면 상단에 표시되면서, 설정에 따라 title을 표시하거나 menu를 구성할 수 있습니다.
    // #ur-gnb is a component that composes the GNB area of ​​the screen.
    // #Displayed at the top of the screen, you can display the title or configure the menu depending on the settings.
    export default {
        name: 'urGnb',
        props: {
            // $ver: v0.2.0
            // GNB의 제목 값입니다.
            // #GNB Title value
            // $tags IDE, title
            title: {
                type: String,
                default: 'SDS Platform'
            },
            // $ver: v0.2.0
            // GNB의 부제목 값입니다.
            // #GNB Sub title value(under the title)
            // $tags IDE, subTitle
            subTitle: {
                type: String,
                default: ''
            },
            // $ver: v0.2.0
            // 메뉴리스트에 보여지는 값들입니다. 배열 타입으로 정의 해야합니다.
            // #A value representing the Menu List. You need to define Array type
            // $tags IDE, topMenu
            topMenu: {
                type: Array,
                default: () => []
            },
            // $ver: v0.2.0
            // gnb에서 햄버거버튼을 사용합니다. multiLine 속성이 활성화될 경우 hamburger 속성은 무시됩니다.
            // #Use a hamburger button on gnb. If the multiLine attribute is activated, hamburger attribute is ignored.
            // $tags IDE, hamburger
            // $default: false
            hamburger: {
                type: Boolean,
                default: false
            },
            // $ver: v0.2.0
            // 메뉴 리스트가 GNB의 중앙에 위치하도록 합니다. logoCenter 와 menuCenter를 함께 사용할 수 없습니다.
            // #The menu list is in the middle of GNB. logoCenter and menuCenter cannot be used at the same time.
            // $tags IDE, menuCenter
            // $default: false
            menuCenter:{
                type: Boolean,
                default: false
            },
            // $ver: v0.2.0
            // GNB에서 검색 입력창을 사용합니다.
            // #Use search box in GNB
            // $default: false
            search: {
                type: Boolean,
                default: false
            },
            // $ver: v0.2.0
            // 검책입력창이 GNB의 중앙에 위치하도록 합니다.
            // #The searchCenter is in the middle of GNB
            // $default: false
            searchCenter:{
                type: Boolean,
                default: false
            },
            // $ver: v0.2.0
            // logo가 GNB의 중앙에 위치하도록 합니다.  multiLine 속성이 활성화될 경우 logoCenter 속성은 무시됩니다.  logoCenter 와 menuCenter를 함께 사용할 수 없습니다.
            // #The logo is in the middle of GNB. If the multiLine attribute is activated, logoCenter attribute is ignored. logoCenter and menuCenter cannot be used at the same time.
            // $tags IDE, logoCenter
            // $default: false
            logoCenter:{
                type: Boolean,
                default: false
            },
            // $ver: v0.2.0
            // GNB가 두줄입니다. multiLine 속성이 활성화될 경우 hamburger, logoCenter 속성은 무시됩니다.
            // #GNB is 2 lines.  If the multiLine attribute is activated, hamburger, logoCenter attribute is ignored.
            // $tags IDE, multiLine
            // $default: false
            multiLine: {
                type: Boolean,
                default: false
            }
        },
        data(){
          return {
              currUri: '',
              searchKeyword: ''
          }
        },
        mounted(){
            this.currUri = (this.topMenu[0] && this.topMenu[0].url)? this.topMenu[0].url : '';
        },
        computed:{
            hasSearch(){
                return (this.search || this.searchCenter);
            },
            hamburgerMenu(){
                let hMenu = [];
                this.topMenu.forEach(menu => {
                    hMenu.push({value: menu.url, text: menu.name})
                });
                return hMenu;
            },
            urGnbStyle(){
                let style = {};
                style['absolute'] = 'absolute';
                //style['top'] = '0px';
                //style['left'] = '0px';
                //style['right'] = '0px';
                return style;
            },
        },
        methods: {
            goToHome() {
                this.$emit('go-home');
            },
            chkMenu(m) {
                // let root = this.rootMenu;
                // if(!root) {return false;}
                return this.currUri.includes(m.url);
            },
            moveMenu(url){
                this.currUri = url;
                this.$emit('move', url);
            },
            doSearch(keyword){
                this.$emit('do-search', keyword);
            }
        }
    };
</script>
